import { render, staticRenderFns } from "./ExamResultModal.vue?vue&type=template&id=1220f155&"
import script from "./ExamResultModal.vue?vue&type=script&lang=js&"
export * from "./ExamResultModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports